import type { DateStr } from 'src/types/common/commonTypes'

import { DTO } from '../DTO'

type ConstructorParams = {
  currentDate?: DateStr<'-'>
} & Partial<res.BeforeAfterDay>

// 이전, 오늘, 이후 날짜
export class BeforeAfterDay extends DTO {
  beforeDate?: DateStr<'-'>
  currentDate?: DateStr<'-'>
  afterDate?: DateStr<'-'>

  constructor(d: Partial<ConstructorParams>) {
    super()
    this.beforeDate = d.beforeDate ?? undefined
    this.currentDate = d.currentDate ?? undefined
    this.afterDate = d.afterDate ?? undefined
  }

  get currentRealDate() {
    if (this.currentDate) {
      return new Date(this.currentDate)
    }
  }

  get isEmpty() {
    return !this.beforeDate && !this.currentDate && !this.afterDate
  }
}
